import { useNavigation } from "@react-navigation/native";
import React, { useCallback, useEffect, useState } from "react";
import { ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import Image from "@components/common/Image";
import { useDispatch, useSelector } from "react-redux";
import Text from "@components/AppText";
import { STORY_EVENTS } from "@constants/analyticsEventsCT";
import color from "@constants/color";
import metrics from "@constants/metrics";
import { actions as miscActions } from "@reducers/miscReducer";
import analytics from "@services/analytics";
import { getData } from "../../lib/storage";

const StoryBanner = ({ cms_item_id, list_items }) => {
  const navigation = useNavigation();
  const [bannerData, setBannerData] = useState([]);
  const dispatch = useDispatch();

  const { user, viewedStories } = useSelector((state) => ({
    user: state.auth.user,
    viewedStories: state.misc.viewedStories,
  }));

  useEffect(() => dispatch(miscActions.hydrateViewedStories()), [dispatch]);

  useEffect(() => {
    const init = async () => {
      try {
        const localViewedStories = (await getData("cmsViewedStories")) || [];
        if (Array.isArray(list_items) && list_items) {
          const { unviewed = [], viewed = [] } = list_items
            ?.map((item) => ({
              id: item.cms_item_id,
              image: item.data?.image_link,
              cl_title: item.data.cl_title,
              cx_title: item.data.cx_title,
            }))
            .reduce(
              (acc, curr) =>
                localViewedStories.includes(curr.id)
                  ? { ...acc, viewed: acc.viewed.concat(curr) }
                  : { ...acc, unviewed: acc.unviewed.concat(curr) },
              { unviewed: [], viewed: [] },
            );
          setBannerData([
            ...(Array.isArray(unviewed) ? unviewed : []),
            ...(Array.isArray(viewed) ? viewed : []),
          ]);
        }
      } catch (e) {
        console.log(e);
      }
    };
    init();
  }, [cms_item_id, list_items]);

  useEffect(() => {
    bannerData.length && sortStoryBanners(bannerData);
  }, [viewedStories, sortStoryBanners, bannerData]);

  const sortStoryBanners = useCallback(
    (data = bannerData) => {
      const { unviewed = [], viewed = [] } = data.reduce(
        (acc, curr) =>
          viewedStories.includes(curr.id)
            ? { ...acc, viewed: acc.viewed.concat(curr) }
            : { ...acc, unviewed: acc.unviewed.concat(curr) },
        { unviewed: [], viewed: [] },
      );

      setBannerData([
        ...(Array.isArray(unviewed) ? unviewed : []),
        ...(Array.isArray(viewed) ? viewed : []),
      ]);
    },
    [bannerData, viewedStories],
  );

  return (
    <ScrollView
      contentContainerStyle={{
        padding: metrics.baseGutter,
        paddingVertical: 5,
      }}
      style={[
        styles.container,
        Array.isArray(bannerData) && bannerData.length
          ? {
              minHeight: 120,
            }
          : null,
      ]}
      horizontal
      showsHorizontalScrollIndicator={false}
    >
      {Array.isArray(bannerData) &&
        bannerData.map((item, index) => {
          const viewed = viewedStories.includes(item.id);
          return (
            <View
              key={item.id}
              style={{
                justifyContent: "center",
                marginRight: 10,
              }}
            >
              <TouchableOpacity
                testID="sb-story-circle"
                style={[
                  styles.circle,
                  {
                    borderColor: viewed ? "rgba(0, 0, 0, 0.36)" : color.primary,
                  },
                ]}
                onPress={() => {
                  analytics.trackEvent(STORY_EVENTS.STORY_CLICKED, {
                    list_name: item.cx_title,
                    list_position: index,
                  });
                  navigation.navigate("Story", {
                    cmsIds: bannerData,
                    userId: user?.user_id,
                    list_position: index,
                  });
                }}
              >
                <Image
                  resizeMethod="scale"
                  resizeMode="cover"
                  style={styles.circleImage}
                  source={{ uri: item.image }}
                />
              </TouchableOpacity>
              <View
                style={{
                  width: 70,
                  flexDirection: "row",
                  flexGrow: 1,
                  flex: 1,
                }}
              >
                <Text
                  style={{
                    fontSize: 11.8,
                    marginTop: 5,
                    flex: 1,
                    flexShrink: 1,
                    flexWrap: "wrap",
                    textAlign: "center",
                    color: viewed ? "rgba(0,0,0,0.36)" : "black",
                  }}
                >
                  {item?.cl_title?.trim()}
                </Text>
              </View>
            </View>
          );
        })}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {},
  circle: {
    height: 60,
    width: 60,
    borderRadius: 60,
    margin: 2,
    borderWidth: 2,
    alignItems: "center",
    justifyContent: "center",
  },
  circleImage: {
    backgroundColor: color.primary,
    height: 52,
    width: 52,
    borderRadius: 50,
  },
});

export default StoryBanner;
